import axios from 'axios';
import { TenantFeatureFlags } from '@repo/types';
import API from '../endpoints';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 30 minutes frontend cache for tenant feature flags query
const CACHE_TIME = 30 * 60 * 1000;

export const useTenantFeatureFlagsQuery = () => {
  return useQuery({
    queryKey: ['tenant-feature-flags'],
    queryFn: fetchTenantFeatureFlags,
    staleTime: !accessToken ? CACHE_TIME : undefined,
  });
};

const fetchTenantFeatureFlags: QueryFunction<TenantFeatureFlags, [string]> = async () => {
  const { data } = await axios.get<TenantFeatureFlags>(`${API.endpoints.tenants}/feature-flags`);
  return data;
};
